import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

type AuthState = {
  jwt: string;
};

const slice = createSlice({
  name: 'auth',
  initialState: { jwt: '' } as AuthState,
  reducers: {
    setCredentials: (
      state,
      {
        payload: { jwt },
      }: PayloadAction<{
        jwt: string;
      }>,
    ) => {
      state.jwt = jwt;
    },
    logout: () => {
      return { jwt: '' };
    },
  },
});

export const { setCredentials, logout } = slice.actions;

export default slice.reducer;

export const selectCurrentUser = (state: RootState) => state.auth;
